// The public site's words (landing, About us, Contact us, Terms, Privacy) in Amharic, Afaan Oromo and Tigrinya, bundled so
// switching the language shows them even before json/languages-landing.add.json is pushed
// to /languages (owner, 5 Nov 2026: "the language is not updated when i switch the lang").
// Words in /languages still win: the page asks i18next first and falls back to these, then
// English. The same words as that file: change both together
// (mobile-app/test/landingPage1105.test.js checks that they match).
const WORDS = {
  am: {
    ab_cta_sub: "ዶንኪ ድራይቭ በአይፎን እና በአንድሮይድ ይገኛል። ጥያቄ አለዎት? ቡድናችን ለመርዳት ዝግጁ ነው።",
    ab_cta_title: "መተግበሪያውን ያውርዱ፣ ወይም ያግኙን",
    ab_fact_address: "አድራሻ",
    ab_fact_company: "ድርጅት",
    ab_facts_title: "ዶንኪ ድራይቭ በአጭሩ",
    ab_hero_sub: "ዶንኪ ድራይቭ በከተማዋ ሁሉ ደንበኞችንና ሹፌሮችን ያገናኛል፤ ዋጋው አስቀድሞ ይታያል፣ እርዳታም በአንድ የስልክ ጥሪ ይገኛል።",
    ab_hero_title: "በአዲስ አበባ የተሰራ፣ በከተማዋ ለሚንቀሳቀስ ሁሉ።",
    ab_story_eyebrow: "የእኛ ታሪክ",
    ab_story_title: "እዚሁ የተሰራ፣ ለምናውቃቸው መንገዶች።",
    ab_v1_d: "ደንበኞች ከማዘዛቸው በፊት ዋጋውን ያያሉ፤ ሹፌሮችም ከመቀበላቸው በፊት ያዩታል።",
    ab_v1_t: "ግልጽ ዋጋ",
    ab_v2_d: "ሹፌሩ እንደተቀበለ ስሙ፣ መኪናው፣ ሰሌዳው እና በስንት ደቂቃ እንደሚደርስ ይታያል።",
    ab_v2_t: "ማን እንደሚመጣ ይወቁ",
    ab_v3_d: "ዝቅተኛ ኮሚሽን፤ እያንዳንዱ ጥያቄም ዋጋውንና የመነሻውን ርቀት አስቀድሞ ያሳያል።",
    ab_v3_t: "ለሹፌሮች ፍትሃዊ",
    ab_v4_d: "እርዳታ ሲፈልጉ ወደ 9260 ይደውሉልን።",
    ab_v4_t: "የሚያናግሩት ሰው",
    ab_values_eyebrow: "የምንቆምለት",
    ab_values_title: "ከእያንዳንዱ ጉዞ ጀርባ ያሉ ቃል ኪዳኖቻችን",
    ct_call_action: "አሁን ይደውሉ",
    ct_call_t: "ይደውሉልን",
    ct_cta_sub: "ጉዞ ይያዙ፣ ሹፌርዎን ይከታተሉ፣ በፈለጉት ይክፈሉ፤ በአይፎን እና በአንድሮይድ።",
    ct_cta_title: "የዶንኪ ድራይቭ መተግበሪያን ያውርዱ",
    ct_email_action: "ይጻፉልን",
    ct_email_t: "ኢሜይል ይላኩልን",
    ct_follow_eyebrow: "ይከተሉን",
    ct_follow_sub: "ከዶንኪ ድራይቭ ዜናና ጠቃሚ ምክሮች፣ ጊዜዎን በሚያሳልፉበት ቦታ።",
    ct_follow_title: "ዶንኪ ድራይቭን ይከተሉ",
    ct_hero_sub: "ስለ ጉዞ፣ ስለ መለያዎ ወይም ከዶንኪ ድራይቭ ጋር ስለ መንዳት ጥያቄ አለዎት? ይደውሉልን፣ ይጻፉልን ወይም ይጎብኙን።",
    ct_hero_title: "ልንረዳዎ ዝግጁ ነን።",
    ct_visit_action: "በካርታ ይክፈቱ",
    ct_visit_t: "ይጎብኙን",
    ct_ways_title: "እኛን የሚያገኙባቸው መንገዶች",
    lg_eyebrow: "ሕጋዊ መረጃ",
    lg_on_this_page: "በዚህ ገጽ",
    lg_privacy_sub: "የምንሰበስበው መረጃ፣ እንዴት እንደምንጠቀምበት እና መለያዎን እንዴት እንደሚሰርዙ።",
    lg_questions_title: "ጥያቄ አለዎት?",
    lg_terms_sub: "ዶንኪ ድራይቭን እንደ ደንበኛ ወይም እንደ ሹፌር ለመጠቀም የሚያስፈልጉ ደንቦች።",
    lp_alt_accepted: "ሹፌርዎ እየመጣ ነው፦ ስም፣ መኪና፣ ሰሌዳ እና የቀሩት ደቂቃዎች",
    lp_alt_confirm: "ማረጋገጫው፦ መንገዱ፣ የመኪና አይነቶቹ እና ዋጋው ከማዘዝዎ በፊት",
    lp_alt_drive: "የሹፌሩ የጉዞ 3D እይታ፣ ጉዞውን ለመጨረስ ማንሸራተቻ ያለው",
    lp_alt_events: "በዋና ገጹ ላይ በአቅራቢያዎ ያሉ ዝግጅቶች",
    lp_alt_finding: "መተግበሪያው ሹፌር ሲፈልግ፣ በአቅራቢያ ያሉ መኪኖች በካርታው ላይ",
    lp_alt_finding_ios: "የአይፎን መተግበሪያው ሹፌር ሲፈልግ፣ በአቅራቢያ ስድስት መኪኖች",
    lp_alt_home: "የዶንኪ ድራይቭ ዋና ገጽ፦ «የት ይሄዳሉ?» እና የቅርብ ጊዜ ቦታዎችዎ",
    lp_alt_home_android: "በአንድሮይድ ላይ ያለው ዋና ገጽ፦ ካርታው፣ «ሹፌር ይፈልጉ» እና «የት ይሄዳሉ?»",
    lp_alt_requests: "የሹፌሩ ጥያቄዎች፣ ከፍተኛ ዋጋ መጀመሪያ",
    lp_alt_stops: "ለጉዞ ሶስተኛ መድረሻ ሲጨመር",
    lp_cta_book: "ጉዞ ይያዙ",
    lp_dl_sub: "ለደንበኞችም ለሹፌሮችም አንድ መተግበሪያ፣ በአይፎን እና በአንድሮይድ።",
    lp_dl_title: "ዶንኪ ድራይቭ በስልክዎ",
    lp_dl_web: "ወይም በድረ-ገጽ ይያዙ",
    lp_drv_b1: "ከፍተኛ ዋጋ መጀመሪያ",
    lp_drv_b2: "ቋሚ ዋጋ ወይም ግምት፣ ሁልጊዜ ተለይቶ",
    lp_drv_b3: "ወደ እያንዳንዱ መነሻ የመንገዱ 3D እይታ",
    lp_drv_b4: "ጉዞውን ለመጨረስ ያንሸራትቱ",
    lp_drv_b5: "ዝቅተኛ ኮሚሽን፣ የበለጠ ገቢ",
    lp_drv_cta: "መተግበሪያውን ያውርዱና መንዳት ይጀምሩ",
    lp_drv_eyebrow: "ለሹፌሮች",
    lp_drv_sub: "እያንዳንዱ ጥያቄ ዋጋውን፣ መነሻው ምን ያህል እንደሚርቅ እና ደንበኛው እንዴት እንደሚከፍል ያሳያል።",
    lp_drv_title: "ዋጋውን ይዩ። ጉዞዎን ይምረጡ።",
    lp_hero_card_cars: "6 መኪኖች በአቅራቢያ",
    lp_hero_card_cars_sub: "ሹፌርዎን አሁን እየፈለግን ነው",
    lp_hero_card_fare: "ከማዘዝዎ በፊት ዋጋው",
    lp_hero_eyebrow: "አሁን በኢትዮጵያ",
    lp_hero_sub: "ከማዘዝዎ በፊት ዋጋውን ይዩ፣ ሹፌርዎ ወደ እርስዎ ሲመጣ ይከታተሉ፣ በጥሬ ገንዘብ፣ በትራንስፈር፣ በካርድ ወይም በኪስ ቦርሳዎ ይክፈሉ።",
    lp_hero_title_a: "በአዲስ አበባ ማንኛውም ጉዞ፣",
    lp_hero_title_b: "በአንድ ታብ።",
    lp_hl_fare_d: "ግምት ወይም ቋሚ ዋጋ፣ ከማዘዝዎ በፊት ይታያል።",
    lp_hl_fare_t: "ዋጋው መጀመሪያ",
    lp_hl_help_d: "ቀንም ማታም ወደ 9260 ይደውሉ።",
    lp_hl_help_t: "በሚፈልጉት ጊዜ እርዳታ",
    lp_hl_pay_d: "በጥሬ ገንዘብ፣ በትራንስፈር፣ በካርድ ወይም በኦንላይን ክፍያ፣ ወይም በዶንኪ ድራይቭ የኪስ ቦርሳዎ።",
    lp_hl_pay_t: "በፈለጉት ይክፈሉ",
    lp_hl_track_d: "ሹፌርዎ እስኪደርስ ድረስ በካርታ ላይ ይከታተሉ።",
    lp_hl_track_t: "የቀጥታ ክትትል",
    lp_how_eyebrow: "እንዴት እንደሚሰራ",
    lp_how_sub: "ከ«የት ይሄዳሉ?» ጀምሮ ሹፌርዎ በር ላይ እስኪደርስ ድረስ፣ በእያንዳንዱ ደረጃ አንድ ግልጽ ገጽ።",
    lp_how_title: "በሶስት ደረጃዎች ጉዞ ይያዙ",
    lp_new_tab: "(በአዲስ ትር ይከፈታል)",
    lp_promises_title: "ደንበኞች ዶንኪ ድራይቭን ለምን ይመርጣሉ",
    lp_skip: "ወደ ዋናው ይዘት ይዝለሉ",
    lp_spot_events_b1: "ኮንሰርቶች፣ እግር ኳስ እና ሌሎችም በአቅራቢያዎ",
    lp_spot_events_b2: "ወደ ቦታው የሚያደርጉት ጉዞ ከዝግጅቱ ይያዛል",
    lp_spot_events_d: "በአዲስ አበባ ያሉ ዝግጅቶችን ይመልከቱ እና ወደ ቦታው ጉዞ ይያዙ።",
    lp_spot_events_t: "ወደ ዝግጅት እየሄዱ ነው?",
    lp_spot_eyebrow: "ለአዲስ አበባ የተሰራ",
    lp_spot_find_b1: "በካርታው ላይ በአቅራቢያ ያሉ መኪኖች",
    lp_spot_find_b2: "ፍለጋው ደረጃ በደረጃ ይሰፋል",
    lp_spot_find_b3: "እየፈለግን ሳለ በማንኛውም ጊዜ መሰረዝ ይችላሉ",
    lp_spot_find_d: "ፍለጋው ደረጃ በደረጃ ሲሰፋ፣ አንድ ሹፌር እስኪቀበል ድረስ በአቅራቢያ ያሉ መኪኖችን ይመልከቱ።",
    lp_spot_find_t: "ሹፌርዎን እናገኛለን",
    lp_spot_stops_b1: "በአንድ ታብ ማቆሚያ ይጨምሩ",
    lp_spot_stops_b2: "በአንድ ጉዞ እስከ ሶስት መድረሻዎች",
    lp_spot_stops_b3: "ማቆሚያን በ«−» ያስወግዱ",
    lp_spot_stops_d: "በጉዞዎ ላይ ማቆሚያ ለመጨመር + ይንኩ፣ ለማስወገድ ደግሞ −።",
    lp_spot_stops_t: "እስከ ሶስት መድረሻዎች",
    lp_spot_sub: "ለአዲስ አበባ መንገዶች እና በየቀኑ ለሚጠቀሙባቸው ስልኮች የተሰራ።",
    lp_spot_title: "ትናንሽ ነገሮች፣ በጥንቃቄ የተሰሩ",
    lp_step1_d: "የቅርብ ጊዜ ቦታዎችዎ በአንድ ታብ ይገኛሉ።",
    lp_step1_t: "የት ይሄዳሉ? ይንኩና ይሂዱ።",
    lp_step2_d: "ከማረጋገጥዎ በፊት መንገድ፣ መኪና እና ዋጋ።",
    lp_step2_t: "ዋጋውን አስቀድመው ይዩ",
    lp_step3_d: "ስም፣ ሰሌዳ እና በስንት ደቂቃ እንደሚደርስ በአንድ እይታ።",
    lp_step3_t: "ማን እንደሚመጣ ይወቁ",
    lp_store_android_alt: "ከGoogle Play ያግኙት",
    lp_store_ios_alt: "ከApp Store ያውርዱ",
    lp_videos_eyebrow: "በተግባር ይመልከቱ",
    lp_videos_title: "መተግበሪያውን በቪዲዮዎቻችን ይማሩ",
  },
  om: {
    ab_cta_sub: "Donkey Drive iPhone fi Android irratti ni argama. Gaaffii qabdaa? Gareen keenya si gargaaruuf qophaa'eera.",
    ab_cta_title: "Appii buufadhu, ykn nu qunnami",
    ab_fact_address: "Teessoo",
    ab_fact_company: "Dhaabbata",
    ab_facts_title: "Donkey Drive gabaabinaan",
    ab_hero_sub: "Donkey Drive magaalattii guutuu keessatti maamiltootaa fi konkolaachisoota wal qunnamsiisa; gatiin dursee ni mul'ata, gargaarsis bilbila tokkoon argama.",
    ab_hero_title: "Finfinnee keessatti kan hojjetame, nama magaalattii keessa sochoo'u hundaaf.",
    ab_story_eyebrow: "Seenaa keenya",
    ab_story_title: "Asitti kan hojjetame, karaawwan nuti beeknuuf.",
    ab_v1_d: "Maamiltoonni osoo hin qabatin dura gatii ni argu; konkolaachisoonnis osoo hin fudhatin dura ni argu.",
    ab_v1_t: "Gatii ifa ta'e",
    ab_v2_d: "Akkuma konkolaachisaan fudhateen maqaa, konkolaataa, gabatee fi daqiiqaa meeqatti akka ga'u ni argita.",
    ab_v2_t: "Eenyu akka dhufu beeki",
    ab_v3_d: "Komishinii gadi aanaa; gaaffiin hundi gatii fi fageenya ka'umsaa dursee agarsiisa.",
    ab_v3_t: "Konkolaachisootaaf haqa qabeessa",
    ab_v4_d: "Yeroo gargaarsa barbaaddu 9260 irratti nu bilbili.",
    ab_v4_t: "Nama itti dubbattu",
    ab_values_eyebrow: "Wanta nuti itti amannu",
    ab_values_title: "Waadaa imala hunda duuba jiru",
    ct_call_action: "Amma bilbili",
    ct_call_t: "Nu bilbili",
    ct_cta_sub: "Imala qabadhu, konkolaachisaa kee hordofi, akka barbaaddetti kaffali; iPhone fi Android irratti.",
    ct_cta_title: "Appii Donkey Drive buufadhu",
    ct_email_action: "Nuuf barreessi",
    ct_email_t: "Imeelii nuuf ergi",
    ct_follow_eyebrow: "Nu hordofi",
    ct_follow_sub: "Oduu fi gorsa Donkey Drive irraa, iddoo yeroo kee itti dabarsitutti.",
    ct_follow_title: "Donkey Drive hordofi",
    ct_hero_sub: "Waa'ee imalaa, herrega keetii ykn Donkey Drive waliin konkolaachisuu irratti gaaffii qabdaa? Nu bilbili, nuuf barreessi ykn nu daawwadhu.",
    ct_hero_title: "Si gargaaruuf qophaa'oodha.",
    ct_visit_action: "Kaartaa irratti bani",
    ct_visit_t: "Nu daawwadhu",
    ct_ways_title: "Karaalee ittiin nu qunnamtu",
    lg_eyebrow: "Odeeffannoo seeraa",
    lg_on_this_page: "Fuula kana irratti",
    lg_privacy_sub: "Odeeffannoo nuti sassaabnu, akkamitti itti fayyadamnu fi herrega kee akkamitti haquu akka dandeessu.",
    lg_questions_title: "Gaaffii qabdaa?",
    lg_terms_sub: "Haalawwan Donkey Drive akka maamilaatti ykn akka konkolaachisaatti itti fayyadamuuf.",
    lp_alt_accepted: "Konkolaachisaan kee karaa irra jira: maqaa, konkolaataa, gabatee fi daqiiqaa hafe",
    lp_alt_confirm: "Mirkaneessa: karaa, gosa konkolaataa fi gatii osoo hin qabatin dura",
    lp_alt_drive: "Mul'ata 3D imalaa konkolaachisaa, imala xumuruuf harkisuu waliin",
    lp_alt_events: "Sagantaalee naannoo kee jiran fuula jalqabaa irratti",
    lp_alt_finding: "Appiin konkolaachisaa barbaada, konkolaattota dhihoo kaartaa irratti",
    lp_alt_finding_ios: "Appiin iPhone konkolaachisaa barbaada, konkolaattota ja'a dhihoo",
    lp_alt_home: "Fuula jalqabaa Donkey Drive: «Eessa deemtu?» fi bakkeewwan yeroo dhihoo",
    lp_alt_home_android: "Fuula jalqabaa Android irratti: kaartaa, «Konkolaachisaa barbaadi» fi «Eessa deemtu?»",
    lp_alt_requests: "Gaaffiiwwan konkolaachisaa, gatii olaanaa dura",
    lp_alt_stops: "Imala tokkoof iddoo itti deemamu sadaffaa dabaluu",
    lp_cta_book: "Imala qabadhu",
    lp_dl_sub: "Appii tokko maamiltootaa fi konkolaachisootaaf, iPhone fi Android irratti.",
    lp_dl_title: "Donkey Drive bilbila kee irratti",
    lp_dl_web: "Ykn marsariitii irratti qabadhu",
    lp_drv_b1: "Gatii olaanaa dura",
    lp_drv_b2: "Gatii murtaa'e ykn tilmaama, yeroo hunda adda baafamee",
    lp_drv_b3: "Gara ka'umsa hundaatti mul'ata karaa 3D",
    lp_drv_b4: "Imala xumuruuf harkisi",
    lp_drv_b5: "Komishinii gadi aanaa, galii dabalataa",
    lp_drv_cta: "Appii buufadhuutii konkolaachisuu jalqabi",
    lp_drv_eyebrow: "Konkolaachisootaaf",
    lp_drv_sub: "Gaaffiin hundi gatii, fageenya ka'umsaa fi akkaataa maamilli itti kaffalu agarsiisa.",
    lp_drv_title: "Gatii ilaali. Imala kee filadhu.",
    lp_hero_card_cars: "Konkolaattota 6 dhihoo",
    lp_hero_card_cars_sub: "Amma konkolaachisaa kee barbaadaa jirra",
    lp_hero_card_fare: "Gatii osoo hin qabatin dura",
    lp_hero_eyebrow: "Amma Itoophiyaa keessatti",
    lp_hero_sub: "Osoo hin qabatin dura gatii ilaali, konkolaachisaan kee gara kee yeroo dhufu hordofi, maallaqaan, ergamaan, kaardiin ykn walleetii keetiin kaffali.",
    lp_hero_title_a: "Imala Finfinnee keessaa hunda,",
    lp_hero_title_b: "tuqaa tokkoon.",
    lp_hl_fare_d: "Tilmaama ykn gatii murtaa'e, osoo hin qabatin dura ni mul'ata.",
    lp_hl_fare_t: "Gatii dura",
    lp_hl_help_d: "Halkanii fi guyyaa 9260 bilbili.",
    lp_hl_help_t: "Yeroo barbaaddu gargaarsa",
    lp_hl_pay_d: "Maallaqaan, ergamaan, kaardiin ykn kaffaltii onlaayinii, ykn walleetii Donkey Drive keetiin.",
    lp_hl_pay_t: "Akka barbaaddetti kaffali",
    lp_hl_track_d: "Hanga konkolaachisaan kee ga'utti kaartaa irratti hordofi.",
    lp_hl_track_t: "Hordoffii yeroo qabatamaa",
    lp_how_eyebrow: "Akkamitti akka hojjetu",
    lp_how_sub: "«Eessa deemtu?» irraa hanga konkolaachisaan kee balbala kee ga'utti, sadarkaa hundaaf fuula ifa ta'e tokko.",
    lp_how_title: "Sadarkaa sadiin imala qabadhu",
    lp_new_tab: "(fuula haaraa irratti banama)",
    lp_promises_title: "Maamiltoonni maaliif Donkey Drive filatu",
    lp_skip: "Gara qabiyyee ce'i",
    lp_spot_events_b1: "Konsartii, kubbaa miillaa fi kanneen biroo naannoo kee",
    lp_spot_events_b2: "Imalli kee gara bakka sagantaa, sagantaa irraa qabatama",
    lp_spot_events_d: "Sagantaalee Finfinnee keessaa ilaaliitii gara bakka sanaa imala qabadhu.",
    lp_spot_events_t: "Gara sagantaa deemtaa?",
    lp_spot_eyebrow: "Finfinneef kan hojjetame",
    lp_spot_find_b1: "Konkolaattota dhihoo kaartaa irratti",
    lp_spot_find_b2: "Barbaacha bal'achaa deemu, sadarkaa sadarkaan",
    lp_spot_find_b3: "Yeroo barbaannu yeroo kamiyyuu haquu dandeessa",
    lp_spot_find_d: "Barbaachi sadarkaa sadarkaan bal'achaa yeroo deemu, hanga konkolaachisaan tokko fudhatutti konkolaattota dhihoo ilaali.",
    lp_spot_find_t: "Konkolaachisaa kee siif barbaanna",
    lp_spot_stops_b1: "Tuqaa tokkoon dhaabbii dabali",
    lp_spot_stops_b2: "Imala tokkotti hanga iddoo itti deemamu sadii",
    lp_spot_stops_b3: "Dhaabbii «−»n haqi",
    lp_spot_stops_d: "Imala keetti dhaabbii dabaluuf + tuqi, haquuf ammoo −.",
    lp_spot_stops_t: "Hanga iddoo itti deemamu sadii",
    lp_spot_sub: "Karaawwan Finfinnee fi bilbilota guyyaa guyyaan fayyadamtuuf kan qophaa'e.",
    lp_spot_title: "Wantoota xixiqqoo, sirriitti",
    lp_step1_d: "Bakkeewwan dhiyeenya kana deemte tuqaa tokkoon argamu.",
    lp_step1_t: "Eessa deemtu? Tuqiitii deemi.",
    lp_step2_d: "Karaa, konkolaataa fi gatii osoo hin mirkaneessin dura.",
    lp_step2_t: "Dursitee gatii ilaali",
    lp_step3_d: "Maqaa, gabatee fi daqiiqaa meeqatti akka ga'u, si'a tokko ilaaluun.",
    lp_step3_t: "Eenyu akka dhufu beeki",
    lp_store_android_alt: "Google Play irraa argadhu",
    lp_store_ios_alt: "App Store irraa buufadhu",
    lp_videos_eyebrow: "Hojii irratti ilaali",
    lp_videos_title: "Appii viidiyoowwan keenyaan baradhu",
  },
  ti: {
    ab_cta_sub: "ዶንኪ ድራይቭ ኣብ ኣይፎንን ኣንድሮይድን ይርከብ። ሕቶ ኣለኩም ዶ? ጉጅለና ክሕግዘኩም ድሉው እዩ።",
    ab_cta_title: "ኣፕ ኣውርዱ፣ ወይ ርኸቡና",
    ab_fact_address: "ኣድራሻ",
    ab_fact_company: "ትካል",
    ab_facts_title: "ዶንኪ ድራይቭ ብሓጺሩ",
    ab_hero_sub: "ዶንኪ ድራይቭ ኣብ መላእ ከተማ ደኣናትን ሹፌራትን የራኽብ፤ ዋጋ ቅድሚ ኩሉ ይርአ፣ ሓገዝ ድማ ብሓንቲ ጻውዒት ይርከብ።",
    ab_hero_title: "ኣብ ኣዲስ ኣበባ ዝተሰርሐ፣ ኣብ ከተማ ንዝንቀሳቐስ ኩሉ።",
    ab_story_eyebrow: "ዛንታና",
    ab_story_title: "ኣብዚ ዝተሰርሐ፣ ነቶም እንፈልጦም መንገድታት።",
    ab_v1_d: "ደኣናት ቅድሚ ምእዛዞም ዋጋ ይርእዩ፤ ሹፌራት ድማ ቅድሚ ምቕባሎም ይርእይዎ።",
    ab_v1_t: "ንጹር ዋጋ",
    ab_v2_d: "ሹፌር ምስ ተቐበለ ስሙ፣ መኪናኡ፣ ታርጋኡን ብኽንደይ ደቒቕ ከም ዝበጽሕን ይርአ።",
    ab_v2_t: "መን ከም ዝመጽእ ፍለጡ",
    ab_v3_d: "ትሑት ኮሚሽን፤ ነፍሲ ወከፍ ሕቶ ድማ ዋጋን ርሕቀት መልዓሊን ኣቐዲሙ የርኢ።",
    ab_v3_t: "ንሹፌራት ፍትሓዊ",
    ab_v4_d: "ሓገዝ ምስ ዘድልየኩም ናብ 9260 ደውሉልና።",
    ab_v4_t: "እትዛረብዎ ሰብ",
    ab_values_eyebrow: "እንቆመሉ",
    ab_values_title: "ድሕሪ ነፍሲ ወከፍ ጉዕዞ ዘለዉ መብጽዓታትና",
    ct_call_action: "ሕጂ ደውሉ",
    ct_call_t: "ደውሉልና",
    ct_cta_sub: "ጉዕዞ ሓዙ፣ ሹፌርኩም ተኸታተሉ፣ ብዝደለኹምዎ ክፈሉ፤ ኣብ ኣይፎንን ኣንድሮይድን።",
    ct_cta_title: "ናይ ዶንኪ ድራይቭ ኣፕ ኣውርዱ",
    ct_email_action: "ጽሓፉልና",
    ct_email_t: "ኢመይል ስደዱልና",
    ct_follow_eyebrow: "ተኸተሉና",
    ct_follow_sub: "ዜናን ጠቓሚ ምኽርታትን ካብ ዶንኪ ድራይቭ፣ ኣብቲ ግዜኹም እተሕልፉሉ።",
    ct_follow_title: "ዶንኪ ድራይቭ ተኸተሉ",
    ct_hero_sub: "ብዛዕባ ጉዕዞ፣ ሕሳብኩም ወይ ምስ ዶንኪ ድራይቭ ምዝዋር ሕቶ ኣለኩም ዶ? ደውሉልና፣ ጽሓፉልና ወይ ብጽሑና።",
    ct_hero_title: "ክንሕግዘኩም ድሉዋት ኢና።",
    ct_visit_action: "ኣብ ካርታ ክፈቱ",
    ct_visit_t: "ብጽሑና",
    ct_ways_title: "ንዓና እትረኽቡሉ መንገድታት",
    lg_eyebrow: "ሕጋዊ ሓበሬታ",
    lg_on_this_page: "ኣብዚ ገጽ",
    lg_privacy_sub: "እንእክቦ ሓበሬታ፣ ብኸመይ ከም እንጥቀመሉን ሕሳብኩም ብኸመይ ከም እትድምስሱን።",
    lg_questions_title: "ሕቶ ኣለኩም ዶ?",
    lg_terms_sub: "ንዶንኪ ድራይቭ ከም ደኣን ወይ ከም ሹፌር ንምጥቃም ዘድልዩ ውዕላት።",
    lp_alt_accepted: "ሹፌርኩም ይመጽእ ኣሎ፦ ስም፣ መኪና፣ ታርጋን ዝተረፋ ደቓይቕን",
    lp_alt_confirm: "ምርግጋጽ፦ መንገዲ፣ ዓይነታት መኪና ከምኡ'ውን ዋጋ ቅድሚ ምእዛዝኩም",
    lp_alt_drive: "ናይ ሹፌር 3D ትርኢት ጉዕዞ፣ ጉዕዞ ንምዝዛም መስሓቢ ዘለዎ",
    lp_alt_events: "ኣብ መእተዊ ገጽ ኣብ ጥቓኹም ዘለዉ ፍጻመታት",
    lp_alt_finding: "እቲ ኣፕ ሹፌር ይደሊ፣ ኣብ ቀረባ ዘለዋ መኪናታት ኣብ ካርታ",
    lp_alt_finding_ios: "ናይ ኣይፎን ኣፕ ሹፌር ይደሊ፣ ኣብ ቀረባ ሽዱሽተ መኪናታት",
    lp_alt_home: "መእተዊ ገጽ ዶንኪ ድራይቭ፦ «ናበይ ትኸዱ?» ከምኡ'ውን ናይ ቀረባ እዋን ቦታታትኩም",
    lp_alt_home_android: "ኣብ ኣንድሮይድ ዘሎ መእተዊ ገጽ፦ ካርታ፣ «ዘዋሪ ድለዩ» ከምኡ'ውን «ናበይ ትኸዱ?»",
    lp_alt_requests: "ሕቶታት ሹፌር፣ ዝለዓለ ዋጋ ቅድሚ ኩሉ",
    lp_alt_stops: "ኣብ ጉዕዞ ሳልሳይ መዕለቢ ምውሳኽ",
    lp_cta_book: "ጉዕዞ ሓዙ",
    lp_dl_sub: "ንደኣናትን ንሹፌራትን ሓደ ኣፕ፣ ኣብ ኣይፎንን ኣንድሮይድን።",
    lp_dl_title: "ዶንኪ ድራይቭ ኣብ ስልክኹም",
    lp_dl_web: "ወይ ብመርበብ ሓዙ",
    lp_drv_b1: "ዝለዓለ ዋጋ ቅድሚ ኩሉ",
    lp_drv_b2: "ዝተወሰነ ዋጋ ወይ ግምት፣ ኩሉ ግዜ ተፈሊዩ",
    lp_drv_b3: "ናብ ነፍሲ ወከፍ መልዓሊ 3D ትርኢት መንገዲ",
    lp_drv_b4: "ጉዕዞ ንምዝዛም ስሓቡ",
    lp_drv_b5: "ትሑት ኮሚሽን፣ ዝበለጸ እቶት",
    lp_drv_cta: "ኣፕ ኣውርዱ እሞ ምዝዋር ጀምሩ",
    lp_drv_eyebrow: "ንሹፌራት",
    lp_drv_sub: "ነፍሲ ወከፍ ሕቶ ዋጋ፣ ርሕቀት መልዓሊን ደኣን ብኸመይ ከም ዝኸፍልን የርኢ።",
    lp_drv_title: "ዋጋ ርኣዩ። ጉዕዞኹም ምረጹ።",
    lp_hero_card_cars: "6 መኪናታት ኣብ ቀረባ",
    lp_hero_card_cars_sub: "ሕጂ ሹፌርኩም ንደሊ ኣለና",
    lp_hero_card_fare: "ቅድሚ ምእዛዝኩም ዋጋ",
    lp_hero_eyebrow: "ሕጂ ኣብ ኢትዮጵያ",
    lp_hero_sub: "ቅድሚ ምእዛዝኩም ዋጋ ርኣዩ፣ ሹፌርኩም ናባኹም ክመጽእ ከሎ ተኸታተሉ፣ ብጥረ ገንዘብ፣ ብትራንስፈር፣ ብካርድ ወይ ብቦርሳኹም ክፈሉ።",
    lp_hero_title_a: "ኣብ ኣዲስ ዝኾነ ጉዕዞ፣",
    lp_hero_title_b: "ብሓንቲ ምጥዋቕ።",
    lp_hl_fare_d: "ግምት ወይ ዝተወሰነ ዋጋ፣ ቅድሚ ምእዛዝኩም ይርአ።",
    lp_hl_fare_t: "ዋጋ ቅድሚ ኩሉ",
    lp_hl_help_d: "ለይትን መዓልትን ናብ 9260 ደውሉ።",
    lp_hl_help_t: "ኣብ ዘድልየኩም እዋን ሓገዝ",
    lp_hl_pay_d: "ብጥረ ገንዘብ፣ ብትራንስፈር፣ ብካርድ ወይ ብኦንላይን ክፍሊት፣ ወይ ብናይ ዶንኪ ድራይቭ ቦርሳኹም።",
    lp_hl_pay_t: "ብዝደለኹምዎ ክፈሉ",
    lp_hl_track_d: "ሹፌርኩም ክሳብ ዝበጽሕ ኣብ ካርታ ተኸታተሉ።",
    lp_hl_track_t: "ቀጥታዊ ክትትል",
    lp_how_eyebrow: "ከመይ ከም ዝሰርሕ",
    lp_how_sub: "ካብ «ናበይ ትኸዱ?» ክሳብ ሹፌርኩም ኣብ ማዕጾ ዝበጽሕ፣ ንነፍሲ ወከፍ ስጉምቲ ሓደ ንጹር ገጽ።",
    lp_how_title: "ብሰለስተ ስጉምቲ ጉዕዞ ሓዙ",
    lp_new_tab: "(ኣብ ሓድሽ ትር ይኽፈት)",
    lp_promises_title: "ደኣናት ስለምንታይ ዶንኪ ድራይቭ ይመርጹ",
    lp_skip: "ናብቲ ትሕዝቶ ሕለፉ",
    lp_spot_events_b1: "ኮንሰርታት፣ ኩዕሶ እግሪን ካልእን ኣብ ጥቓኹም",
    lp_spot_events_b2: "ናብቲ ቦታ እትገብርዎ ጉዕዞ ካብቲ ፍጻመ ይተሓዝ",
    lp_spot_events_d: "ኣብ ኣዲስ ዘለዉ ፍጻመታት ርኣዩ እሞ ናብቲ ቦታ ጉዕዞ ሓዙ።",
    lp_spot_events_t: "ናብ ፍጻመ ትኸዱ ዶ?",
    lp_spot_eyebrow: "ንኣዲስ ዝተሰርሐ",
    lp_spot_find_b1: "ኣብ ካርታ ኣብ ጥቓኹም ዘለዋ መኪናታት",
    lp_spot_find_b2: "ደረጃ ብደረጃ ዝሰፍሕ ምድላይ",
    lp_spot_find_b3: "ክንደሊ ከለና ኣብ ዝኾነ እዋን ሰርዙ",
    lp_spot_find_d: "ምድላይ ብደረጃ እናሰፍሐ፣ ሓደ ሹፌር ክሳብ ዝቕበል ኣብ ቀረባ ዘለዋ መኪናታት ርኣዩ።",
    lp_spot_find_t: "ሹፌርኩም ንረኽበልኩም",
    lp_spot_stops_b1: "ብሓንቲ ምጥዋቕ ደው መበሊ ወስኹ",
    lp_spot_stops_b2: "ኣብ ሓደ ጉዕዞ ክሳብ ሰለስተ መዕለቢታት",
    lp_spot_stops_b3: "ደው መበሊ ብ«−» ኣልግሱ",
    lp_spot_stops_d: "ኣብ ጉዕዞኹም ደው መበሊ ንምውሳኽ + ጠውቑ፣ ንምእላይ ድማ −።",
    lp_spot_stops_t: "ክሳብ ሰለስተ መዕለቢታት",
    lp_spot_sub: "ንጽርግያታት ኣዲስን ንመዓልታዊ እትጥቀሙሎም ስልኪታትን ዝተሰርሐ።",
    lp_spot_title: "ናእሽቱ ነገራት፣ ብቕኑዕ",
    lp_step1_d: "ናይ ቀረባ እዋን ቦታታትኩም ብሓንቲ ምጥዋቕ ይርከቡ።",
    lp_step1_t: "ናበይ ትኸዱ? ጠውቑ እሞ ኪዱ።",
    lp_step2_d: "ቅድሚ ምርግጋጽኩም መንገዲ፣ መኪናን ዋጋን።",
    lp_step2_t: "ዋጋ ኣቐዲምኩም ርኣዩ",
    lp_step3_d: "ስም፣ ታርጋን ብኽንደይ ደቒቕ ከም ዝበጽሕን ብሓደ ጠመተ።",
    lp_step3_t: "መን ከም ዝመጽእ ፍለጡ",
    lp_store_android_alt: "ካብ Google Play ርኸብዎ",
    lp_store_ios_alt: "ካብ App Store ኣውርዱ",
    lp_videos_eyebrow: "ብተግባር ርኣዩ",
    lp_videos_title: "ነቲ ኣፕ ብቪድዮታትና ተማሃሩ",
  },
};

// The word for `key` in `language` (am, om, ti; a region suffix is ignored), else `en`.
export default function landingWord(language, key, en) {
  const pack = WORDS[String(language || '').slice(0, 2).toLowerCase()];
  return (pack && pack[key]) || en;
}
